<template>
<b-container>
  <div >

      <!--<b-form @submit="onSubmit" @reset="onReset">-->
        
      <b-form >
        <b-row>
            <b-col md="6">
              <label for="data-arrivo">Data Checkin</label>
              <b-form-datepicker id="data-arrivo" v-model="form.arrivo" class="mb-2"></b-form-datepicker>
            </b-col>
            <b-col md="6">
              <label for="data-partenza">Data Checkout</label>
              <b-form-datepicker id="data-partenza" v-model="form.partenza" class="mb-2"></b-form-datepicker>
            </b-col>
        </b-row>
      <b-form-group id="input-group-2" label="Your Name:" label-for="input-2">
        <b-form-input
          id="input-2"
          v-model="form.nominativo"
          placeholder="Enter name"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group
        id="input-group-1"
        label="Email address:"
        label-for="input-1"
        description="We'll never share your email with anyone else."
      >
        <b-form-input
          id="input-1"
          v-model="form.email"
          type="email"
          placeholder="Enter email"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group
        id="input-group-3"
        label="Telefono:"
        label-for="input-tel"
        description="Inserisci un recapito telefonico per ricevere un contattao via whatsapp"
      >
        <b-form-input
          id="input-tel"
          v-model="form.telefono"
          type="text"
          placeholder="Enter phone number"
          required
        ></b-form-input>
      </b-form-group>

      <template v-for="camera in form.camere">
        <div :key="`div_card_cam${camera.id}`" class="mb-1">
        <b-card
        :key="`card_cam${camera.id}`"
        :title="`Camera ${camera.id}`"
        dense>
        <b-row>
          <b-col md="3">
              <b-form-group id="input-group-3" label="Arrangiamento" :label-for="'arr'+camera.id">
              <b-form-select
                :key="'arr'+camera.id"
                :id="'arr'+camera.id"
                v-model="form.trattamento"
                :options="trattamenti"
                required
              ></b-form-select>
            </b-form-group>
          </b-col>
            <b-col  md="2">
              <b-form-group 
                :key="camera.id"
                id="input-group-adu"
                label="Adulti"
                label-for="input-adu"
                description="Numero di adulti"
              >
                <b-form-input
                  id="input-adu"
                  v-model="camera.adulti"
                  type="number"
                  placeholder="2"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group 
              :key="camera.id"
              id="input-group-bam"
              label="Bambini"
              label-for="input-bam"
              description="Numero di bambini"
            >
              <b-form-input
                id="input-bam"
                v-model="camera.bambini"
                type="number"
                placeholder="0"
                required
              ></b-form-input>
            </b-form-group>
            </b-col>
            <b-col md="5" v-if="camera.bambini>0">
               <label>Età bambini</label>
                <b-form-group 
                    :key="'gr_eta_bambini'" 
                    id="input-group-bam"
                    label=""
                    :description="'Età dei bambini '"
                  >
                <template v-for="bambino in Number(camera.bambini)">   
                <b-form-input
                  :key="'eta'+bambino" 
                  :id="'eta'+bambino+'-'+camera.id" 
                  type="number"
                  placeholder="0"
                  required
                ></b-form-input>
                

              </template>
              </b-form-group>
            </b-col>
        </b-row>



          <b-button @click="EliminaCamera(camera)" variant="danger">Elimina</b-button>
        </b-card>
        </div>

      </template>






      <b-button type="submit" variant="primary">Submit</b-button>
      <b-button type="reset" variant="danger">Reset</b-button>
    </b-form>

    <b-card class="mt-3" header="Form Data Result">
      <pre class="m-0">{{ form }}</pre>
    </b-card>
  </div>
  </b-container>
</template>
<script>
  export default {
    data: () => ({
      trattamenti:['BB','HB','FB'],
      form:{
        nominativo:'',
        email:'',
        arrivo:'',
        partenza:'',
        checked:[],
        ncamere:1,
        camere:[
          {id:1,adulti:2,bambini:0,eta:[]},
          {id:2,adulti:2,bambini:1,eta:[]}
        ]
      },
  }),
  methods:{
      EliminaCamera(camera)
      {
          var i =this.form.camere.indexOf(camera);
          this.form.camere.splice(i,1)
      }  
    }
  }
</script>